// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteAccountCancelWorkflowDefaultResponse {
    static getAttributeTypeMap() {
        return SiteAccountCancelWorkflowDefaultResponse.attributeTypeMap;
    }
}
SiteAccountCancelWorkflowDefaultResponse.discriminator = undefined;
SiteAccountCancelWorkflowDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "object"
    }
];
//# sourceMappingURL=siteAccountCancelWorkflowDefaultResponse.js.map